module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-inner-1100.c8ad7641.svg";